import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { createAsyncAction, errorAction } from 'swag-client-common/libs/redux-helpers';
import { OrderApi } from 'swag-client-common/api/order.api';
import { PRODUCTION_MOCKUP_STATUSES } from 'swag-common/constants/order-statuses.constants';
const PREFIX = 'MOCKUP_MANAGER_';
export const USER_SKIPPED_BEFORE_APPROVING_MOCKUP = `${PREFIX}USER_SKIPPED_BEFORE_APPROVING_MOCKUP`;
export const skipBeforeApprovingMockup = () => ({
  type: USER_SKIPPED_BEFORE_APPROVING_MOCKUP
});
export const RESET_STATE = `${PREFIX}RESET_STATE`;
export const resetMockupManagerState = () => ({
  type: RESET_STATE
});
export const VIEWING_MOCKUP = `${PREFIX}VIEWING_MOCKUP`;
export const viewMockup = ({
  productionMockups = [],
  orderId,
  itemId
}) => {
  const mockups = productionMockups;
  const mockup = mockups.find(currentMockup => currentMockup.status === PRODUCTION_MOCKUP_STATUSES.PENDING_CUSTOMER_APPROVAL);
  return {
    type: VIEWING_MOCKUP,
    mockup,
    orderId,
    itemId
  };
};
export const EDIT_MOCKUP_CHANGE_REQUEST = `${PREFIX}EDIT_MOCKUP_CHANGE_REQUEST`;
export const editMockupChangeRequest = value => ({
  type: EDIT_MOCKUP_CHANGE_REQUEST,
  value
});
export const REQUEST_CHANGES = `${PREFIX}REQUEST_CHANGES`;
export const requestChanges = payload => ({
  type: REQUEST_CHANGES,
  payload
});
export const REQUESTING_CHANGES_MOCKUP_STARTED = `${PREFIX}REQUESTING_CHANGES_MOCKUP_STARTED`;
export const REQUESTING_CHANGES_ERROR = `${PREFIX}REQUESTING_CHANGES_MOCKUP_ERROR`;
export const REQUESTING_CHANGES_SUCCESS = `${PREFIX}REQUESTING_CHANGES_MOCKUP_SUCCESS`;
export const requestMockupChanges = createAsyncAction({
  preFn: dispatch => {
    dispatch({
      type: REQUESTING_CHANGES_MOCKUP_STARTED
    });
  },
  fn: OrderApi.reviewMockup,
  success: order => ({
    type: REQUESTING_CHANGES_SUCCESS,
    order
  }),
  error: errorAction(REQUESTING_CHANGES_ERROR),
  postSuccess: dispatch => {
    dispatch(hidePopup());
  }
});
export const APPROVING_MOCKUP_STARTED = `${PREFIX}APPROVING_MOCKUP_STARTED`;
export const APPROVING_ERROR = `${PREFIX}APPROVING_MOCKUP_ERROR`;
export const APPROVING_SUCCESS = `${PREFIX}APPROVING_MOCKUP_SUCCESS`;
export const approveMockup = createAsyncAction({
  preFn: dispatch => {
    dispatch({
      type: APPROVING_MOCKUP_STARTED
    });
  },
  fn: OrderApi.reviewMockup,
  success: order => ({
    type: APPROVING_SUCCESS,
    order
  }),
  error: errorAction(APPROVING_ERROR),
  postSuccess: dispatch => {
    dispatch(hidePopup());
  }
});